import { Component, OnInit, Inject } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import {
  HttpClient,
  HttpHeaders,
  HttpErrorResponse
} from "@angular/common/http";
import { ActivatedRoute, Router } from "@angular/router";

@Component({
  selector: "app-naac-sub-heading-create",
  templateUrl: "./naac-sub-heading-create.component.html",
  styleUrls: ["./naac-sub-heading-create.component.scss"]
})
export class NaacSubHeadingCreateComponent implements OnInit {
  constructor(
    private formBuilder: FormBuilder,
    private http: HttpClient,
    private ActivatedRoute: ActivatedRoute,
    private router: Router,
    @Inject("API_ENDPOINT") private api_endpoint: string
  ) {}

  message = null;
  class = null;
  action = null;
  submitted = false;
  public Form: FormGroup;
  headings: [];

  ngOnInit() {
    this.action = "Submit";
    this.ActivatedRoute.params.subscribe((params) => {
      let id = params["id"];

      this.http
        .get<any>(this.api_endpoint + "/naac-sub-heading-by-id/" + `${id}`)
        .subscribe(
          (data) => {
            if (data.data != null) {
              this.action = "Update";
              this.Form.patchValue({
                _id: data.data._id,
                headingId: data.data.headingId,
                heading: data.data.heading,
                description: data.data.description
              });
            }
          },
          (err: HttpErrorResponse) => {
            if (err.error instanceof Error) {
              console.log("Client-side error occured.");
            } else {
              console.log("Server-side error occured.");
            }
          }
        );
    });

    this.Form = this.formBuilder.group({
      headingId: ["", Validators.required],
      heading: ["", Validators.required],
      description: [""],
      _id: [""]
    });

    this.http.get<any>(this.api_endpoint + "/naac-heading/").subscribe(
      (data) => {
        this.headings = data.data;
        // console.log(this.pages);
      },
      (err: HttpErrorResponse) => {
        if (err.error instanceof Error) {
          console.log("Client-side error occured.");
        } else {
          console.log("Server-side error occured.");
        }
      }
    );
  }

  get f() {
    return this.Form.controls;
  }

  onFormSubmit() {
    this.submitted = true;

    if (this.Form.invalid) {
      return;
    }

    var data = {
      headingId: this.Form.value.headingId,
      heading: this.Form.value.heading,
      description: this.Form.value.description,
      _id: this.Form.value._id
    };

    if (this.action == "Submit") {
      delete data._id;
      this.http
        .post<any>(this.api_endpoint + "/naac-sub-heading", data)
        .subscribe(
          (res) => {
            console.log(res);
            if (res.Error) {
              this.message = res.Error;
              this.class = "btn btn-primary";
              return;
            } else {
              this.message = "Successfully Added";
              this.class = "btn btn-success";
            }
            this.router.navigateByUrl(
              "/adminhkbkcms/naac-sub-heading/list-page"
            );
          },
          (err: HttpErrorResponse) => {
            if (err.error instanceof Error) {
              console.log("Client-side error occured.");
            } else {
              console.log("Server-side error occured.");
            }
          }
        );
    } else {
      this.http
        .put<any>(this.api_endpoint + "/naac-sub-heading/", data)
        .subscribe(
          (res) => {
            console.log(res);
            if (res.Error) {
              this.message = res.Error;
              this.class = "btn btn-primary";
              return;
            } else {
              this.message = "Successfully Added";
              this.class = "btn btn-success";
            }
            this.router.navigateByUrl(
              "/adminhkbkcms/naac-sub-heading/list-page"
            );
          },
          (err: HttpErrorResponse) => {
            if (err.error instanceof Error) {
              console.log("Client-side error occured.");
            } else {
              console.log("Server-side error occured.");
            }
          }
        );
    }
  }
}
